import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, ease: "easeOut", delay }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ children }) => (
  <p className="text-xs font-medium uppercase tracking-[0.3em] text-brand-red mb-6">{children}</p>
);
